/**
 * 格式化显示邮箱：如果邮箱包含冒号（如 OAuth 登录的 "oauth\Google:xxx@gmail.com"），
 * 取冒号后面的部分显示；没有冒号则原样返回。
 */
export const formatDisplayEmail = (email?: string): string => {
  if (!email) return '';
  const colonIndex = email.indexOf(':');
  return colonIndex !== -1 ? email.slice(colonIndex + 1) : email;
};

/**
 * 公司级角色：公司所有者与公司管理员。
 * 设置这两类角色时部门可不选；不选时部门 ID 传 NO_DEPARTMENT_ID。
 */
export const COMPANY_LEVEL_ROLE_CODES = ['ROLE_COMPANY_OWNER', 'ROLE_ADMIN'];

/** 未选择部门时传给后端的部门 ID（0 表示无部门） */
export const NO_DEPARTMENT_ID = '0';

/** 判断指定角色是否为可不选部门的公司级角色（公司所有者 / 公司管理员） */
export const isCompanyLevelRole = (roleCode?: string): boolean =>
  !!roleCode && COMPANY_LEVEL_ROLE_CODES.includes(roleCode);
